export default "__VITE_ASSET__EpYK0w5S__"